import { FcsFlag } from "../unleash";

/* eslint-disable @typescript-eslint/camelcase */
export const FlagsPermissionDexAssessment = {
  permission_dex_assessment_customer_service_l1_enable: new FcsFlag.Flag(false),
  permission_dex_assessment_customer_service_l2_enable: new FcsFlag.Flag(false),
  permission_dex_assessment_customer_consolidator_enable: new FcsFlag.Flag(
    false
  ),
  permission_dex_assessment_admin_enable: new FcsFlag.Flag(false),
  permission_dex_assessment_admin_dashboard_enable: new FcsFlag.Flag(false),
  permission_dex_assessment_dashboard_consolidator_enable: new FcsFlag.Flag(
    false
  )
};

export function initFlagsPermissionDexAssessment() {
  // register flags with namespaces for better grouping
  FcsFlag.register("featureDexAssessment", FlagsPermissionDexAssessment);
}
